import apiClient from './apiClient'

export interface Notification {
  notification_id: number
  subject: string | null
  first_name: string
  last_name: string
  created_at: number  // Unix timestamp in seconds
  is_read: string | null  // '1' or null
  notes: string
  notes_for: string | null  // 'USER', 'APPLICATION', 'COMPANY', 'PROPERTY', 'TRANSFER_LOG', 'UNDERWRITER', etc.
  fk_ref_id: number | null
  start_date: string | null
  end_date: string | null
}

/** Full notification payload from GET /api/user_notification/:id */
export interface NotificationDetail extends Notification {
  ref_user_id?: number | null
  ref_name?: string | null
  details?: {
    start_date?: string
    end_date?: string
    additional_desc?: string
  }
}

export interface NotificationResponse {
  current: number
  total: number
  last: number
  data: Notification[]
}

/**
 * Fetch user notifications
 * @param userId - ID of the user to fetch notifications for
 * @param perPage - Number of notifications to fetch (default: 100)
 */
export async function fetchUserNotifications(
  userId: number,
  perPage: number = 100,
): Promise<NotificationResponse> {
  const response = await apiClient.get<NotificationResponse>('/api/user_notification', {
    params: {
      userId,
      perPage,
    },
  })

  return response.data
}

/**
 * Fetch a single notification detail (matches Angular loadNotificationDetail).
 */
export async function fetchUserNotificationDetail(
  notificationId: number,
): Promise<NotificationDetail> {
  const response = await apiClient.get<NotificationDetail>(
    `/api/user_notification/${notificationId}`,
  )
  return response.data
}

/**
 * Mark all user notifications as read (matches Angular markAllRead).
 */
export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.post('/api/user_notification_read_all')
}
